// src/components/ReferidosModal.jsx
import ReactDOM from "react-dom";

const ReferidosModal = ({ user, onClose }) => {
  if (!user) return null;

  return ReactDOM.createPortal(
    <div className="referidos-modal-overlay">
      <div className="referidos-modal">
        <img className="referidos-foto" src={user.foto || "/assets/images/5.png"} alt="Usuario" />
        <h3 className="referidos-nombre">{user.nombre}</h3>
        <p className="referidos-desc">¡Gana dinero por referir comercios!</p>
        <small className="referidos-info">
          Comparte tu código de referido y gana Q15 por cada comercio que se registre con tu código.
        </small>
        <div className="referidos-codigo">
          <code>{user.codigo}</code>
          <button className="referidos-copy" onClick={() => navigator.clipboard.writeText(user.codigo)}>
            Copiar
          </button>
        </div>
        <button className="referidos-cerrar" onClick={onClose}>CERRAR</button>
      </div>
    </div>,
    document.body
  );
};

export default ReferidosModal;
